import { render, staticRenderFns } from "./recommendJobList.vue?vue&type=template&id=82d87a84&scoped=true"
import script from "./recommendJobList.vue?vue&type=script&lang=js"
export * from "./recommendJobList.vue?vue&type=script&lang=js"
import style0 from "./recommendJobList.vue?vue&type=style&index=0&id=82d87a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d87a84",
  null
  
)

export default component.exports